export const WELL_CONTROL_ACTIONS = {
  GET_ALL_CATEGORIES_AND_SITUATIONS: 'GET_ALL_CATEGORIES_AND_SITUATIONS',
  UPDATE_WELL_CONTROLL_DRILL_ACTIVITY: 'UPDATE_WELL_CONTROLL_DRILL_ACTIVITY',
};
